function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import I18nProvider from './I18nProvider';
import { I18n } from './i18nContext';

class I18nLoader extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      phrasesByLocale: {}
    });

    _defineProperty(this, "loadLocale", async locale => {
      const loadPhrases = this.props.loadPhrases;
      const phrases = await loadPhrases(locale);
      this.setState(state => ({
        phrasesByLocale: _objectSpread({}, state.phrasesByLocale, {
          [locale]: phrases
        })
      }));
    });
  }

  componentDidMount() {
    this.loadLocale(this.props.locale);
  }

  componentDidUpdate(prevProps) {
    const phrasesByLocale = this.state.phrasesByLocale; // if language changed and we don't have it in state already, then load it

    if (this.props.locale !== prevProps.locale && !phrasesByLocale[this.props.locale]) {
      this.loadLocale(this.props.locale);
    }
  }

  render() {
    const _this$props = this.props,
          children = _this$props.children,
          locale = _this$props.locale;
    const phrasesByLocale = this.state.phrasesByLocale; // Skip rendering when catalog isn't loaded.

    if (!phrasesByLocale[locale]) {
      return null;
    }

    return /*#__PURE__*/React.createElement(I18nProvider, {
      locale: locale,
      phrases: phrasesByLocale[locale]
    }, children);
  }

}

_defineProperty(I18nLoader, "defaultProps", {});

const I18nLoaderProvider = (_ref) => {
  let locale = _ref.locale,
      restProps = _objectWithoutProperties(_ref, ["locale"]);

  return /*#__PURE__*/React.createElement(I18n, null, translator => {
    return /*#__PURE__*/React.createElement(I18nLoader, _extends({
      locale: locale || translator.locale()
    }, restProps));
  });
};

export default I18nLoaderProvider;